import isSvgUrl from './isSvgUrl';
export default function getFallbackUrl(url, dimension, size, quality) {
  if (!isSvgUrl(url)) {
    return `${url}?${dimension}=${size}&q=${quality}`;
  }
  return url;
}